// src/utils/api.js
import axiosInstance from '../services/AxiosInstance';
import { ROUTES } from '../const/routes';

export const fetchUserData = async (navigate, setUserData) => {
  try {
    const response = await axiosInstance.get('/api/auth/status');

    if (response.data?.authenticated === false) {
      setUserData(null);
      navigate(ROUTES.home);
      return;
    }

    setUserData(response.data);
  } catch (error) {
    navigate(ROUTES.home);
  }
};
